var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49 5.978a1.402 1.402 0 100 2.804 1.402 1.402 0 000-2.804zm-4.5 1.956h2.184a2.381 2.381 0 004.631 0 .5.5 0 00.032 0h7.174a.49.49 0 000-.978H9.832a2.381 2.381 0 00-4.685 0H2.989a.49.49 0 100 .978zm14.02 4.892a.49.49 0 010 .978h-2.184a2.381 2.381 0 01-4.631-.001.478.478 0 01-.032 0H2.989a.49.49 0 110-.977h7.179a2.381 2.381 0 014.685 0h2.158zm-3.097.424a1.402 1.402 0 10-2.805 0 1.402 1.402 0 002.805 0z",
    fill: "#C4C4C4"
  })));
}
export default SvgMoreFilters;